import { Modal } from 'react-bootstrap';
import React, { memo } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import RespawnReal from '../../Respawn/RespawnReal';
import styled from 'styled-components';
import {
    RespawnRealBottomStyled,
    RespawnRealSuccessContentContainerStyled,
} from '../../Respawn/styled/RespawnRealStyled';

const RespawnRealStyled = styled(RespawnReal)`
    &.success {
        justify-content: center;

        ${RespawnRealSuccessContentContainerStyled} {
            flex: unset;
        }
    }
    
    &.info {
        ${RespawnRealBottomStyled} {
            margin-right: 16px;
            margin-left: 16px;
        }
    }
`;

function RespawnModal() {
    const { getLangPath } = useLangContext();

    return <>
        <Modal.Header closeButton>
            {getLangPath('bonus.new_life.respawn_title')}
        </Modal.Header>
        <Modal.Body>
            <RespawnRealStyled/>
        </Modal.Body>
    </>;
}

export default memo(RespawnModal);
